import { LOGOUT_ACTION, RESET_ACTION } from '@/constants/actions'

/**
 * Helper function to create extraReducers that handle logout action
 * Use this in your slice's extraReducers to reset state on logout
 *
 * @param initialState - The initial state to reset to on logout
 * @returns Object with extraReducers that handle both RESET and logout actions
 */
export const createLogoutExtraReducers = <T>(initialState: T) => ({
  [LOGOUT_ACTION]: () => initialState,
  [RESET_ACTION]: () => initialState
})

export type LogoutExtraReducers<T> = ReturnType<typeof createLogoutExtraReducers<T>>
